import React from 'react';
import { Phone, Mail, MapPin, Clock, Instagram, Facebook, Youtube } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-secondary-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 lg:col-span-2">
            <h3 className="text-2xl font-bold text-primary-400 mb-4">
              Will Performance
            </h3>
            <p className="text-gray-300 mb-4 leading-relaxed">
              Referência em preparação de carros turbos em SP. Há mais de 20 anos oferecendo 
              serviços de mecânica, performance e funilaria com qualidade e preços justos.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/willperformance.oficial/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary-400 transition-colors duration-200"
              >
                <Instagram className="h-6 w-6" />
              </a>
              <a
                href="https://www.facebook.com/Willperformance147"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary-400 transition-colors duration-200"
              >
                <Facebook className="h-6 w-6" />
              </a>
              <a
                href="https://www.youtube.com/@willperformance4380"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary-400 transition-colors duration-200"
              >
                <Youtube className="h-6 w-6" />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contato</h4>
            <div className="space-y-3">
              <div className="flex items-center">
                <Phone className="h-5 w-5 mr-3 text-primary-400" />
                <div>
                  <p className="text-sm text-gray-300">Atendimento</p>
                  <p className="font-medium">(11) 2359-3715</p>
                </div>
              </div>
              <div className="flex items-center">
                <Phone className="h-5 w-5 mr-3 text-primary-400" />
                <div>
                  <p className="text-sm text-gray-300">Técnico</p>
                  <p className="font-medium">(11) 94714-1617</p>
                </div>
              </div>
              <div className="flex items-center">
                <Mail className="h-5 w-5 mr-3 text-primary-400" />
                <div>
                  <p className="text-sm text-gray-300">Email</p>
                  <p className="font-medium">contato@willperformance.com.br</p>
                </div>
              </div>
            </div>
          </div>

          {/* Location & Hours */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Localização</h4>
            <div className="space-y-3">
              <div className="flex items-start">
                <MapPin className="h-5 w-5 mr-3 text-primary-400 mt-1" />
                <div>
                  <p className="text-sm text-gray-300">Endereço</p>
                  <p className="font-medium">R. Tiúba, 378</p>
                  <p className="font-medium">Vila Nova Manchester</p>
                  <p className="font-medium">São Paulo - SP</p>
                </div>
              </div>
              <div className="flex items-start">
                <Clock className="h-5 w-5 mr-3 text-primary-400 mt-1" />
                <div>
                  <p className="text-sm text-gray-300">Horário</p>
                  <p className="font-medium">Seg-Sex: 8h às 18h</p>
                  <p className="font-medium">Sáb: 8h às 13h</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* WhatsApp CTA */}
        <div className="mt-8 pt-8 border-t border-secondary-700 text-center">
          <a
            href="https://api.whatsapp.com/send?phone=551123593715"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-green-500 hover:bg-green-600 text-white px-8 py-3 rounded-lg font-medium transition-colors duration-200"
          >
            <Phone className="h-5 w-5 mr-2" />
            Fale Conosco pelo WhatsApp
          </a>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-secondary-700 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Will Performance. Todos os direitos reservados.</p>
          <p className="text-xs mt-2">
            Desenvolvido por{' '}
            <a 
              href="https://kiani.com.br" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-primary-400 hover:text-primary-300 transition-colors duration-200"
            >
              Kiani Serviços Digitais LTDA
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
